<template>
    <AppModal :title="$t('labels.edit_product_price_template')" ref="modal">
        <div class="modal-body">
            <template v-if="task.state.isRunning">
                <TaskProgressBar :done="task.state.done" :total="task.state.total"/>
            </template>
            <template v-else>
                <FormGroup :label="$t('labels.price_template')">
                    <AppAutoComplete
                        :url="priceTemplatesUrl"
                        :model-value="priceTemplate?.uuid"
                        :selected-value="priceTemplate?.name"
                        @update:model-value="priceTemplate = $event"
                    />
                </FormGroup>
            </template>
        </div>
        <div class="modal-footer" v-if="!task.state.isRunning">
            <AppButton color="indigo" @click="applyPriceTemplate" :disabled="!priceTemplate">
                {{ $t('buttons.apply') }}
            </AppButton>
        </div>
    </AppModal>
</template>
<script>
import AppModal from '../../../../../components/new/modal/AppModal.vue';
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import AppAutoComplete from '../../../../../components/new/form/autocomplete/AppAutoComplete.vue';
import AppButton from '../../../../../components/new/button/AppButton.vue';
import TaskProgressBar from '../../../../../components/new/progress/TaskProgressBar.vue';

import { httpClient } from '../../../../../services/HttpClient';
import HttpRequest from '../../../../../services/Http/HttpRequest';
import HttpSender from '../../../../../services/Http/HttpSender';
import { createProgressTask } from '../../../../../services/Progress/ProgressTask';

export default {
    name: "EditProductPriceTemplateModal",
    components: {
        AppModal, FormGroup, AppAutoComplete, AppButton, TaskProgressBar
    },
    emits: ['price-template:applied'],
    data() {
        return {
            task: createProgressTask(),
            selectedProductUuids: [],
            priceTemplate: null
        }
    },
    computed: {
        priceTemplatesUrl() {
            return `/projects/${this.$route.params.projectUuid}/pim/price-templates`;
        },
    },
    methods: {
        show(selectedProductUuids) {
            this.selectedProductUuids = selectedProductUuids;
            this.$refs.modal.show();
        },
        hide() {
            this.task.cancel();
            this.$refs.modal.hide();
            this.priceTemplate = null;
            this.selectedProductUuids = [];
        },
        async fetchOrderProducts(selectedProductUuids) {
            return await httpClient.get(`/projects/${this.$route.params.projectUuid}/crm/orders/${this.$route.params.orderUuid}/products`, {
                uuids: selectedProductUuids,
                extra_fields: ['product'],
                limit: 100
            }).then((response) => {
                return response.data.data;
            })
        },
        async applyPriceTemplate() {
            const completed = await this.task.run(async (progress) => {
                const orderProducts = await this.fetchOrderProducts(this.selectedProductUuids);
                const priceTemplateValuesByOrderProductUuid = await this.fetchPriceTemplateValues(orderProducts, progress);

                const updateOrderProductPriceRequests = Object
                    .entries(priceTemplateValuesByOrderProductUuid)
                    .map(([orderProductUuid, priceTemplateValues]) => new HttpRequest(
                        'PATCH',
                        `/projects/${this.$route.params.projectUuid}/crm/orders/${this.$route.params.orderUuid}/products/${orderProductUuid}`,
                        {price: priceTemplateValues},
                    ));

                await new HttpSender().sendRequestsInBatches(updateOrderProductPriceRequests, () => progress.tick());
            });

            if (completed) {
                this.hide();
                this.$emit('price-template:applied');
            }
        },
        async fetchPriceTemplateValues(orderProducts, {tick}) {
            let getPriceTemplateValuesRequests = [];
            let priceTemplateValuesByOrderProductUuid = {};

            for (let orderProduct of orderProducts) {
                let request = new HttpRequest('GET', `/catalog/product-items/${orderProduct.product.uuid}`)

                getPriceTemplateValuesRequests.push(request);
            }

            await new HttpSender().sendRequestsInBatches(getPriceTemplateValuesRequests, (request, response, index) => {
                tick();
                priceTemplateValuesByOrderProductUuid[orderProducts[index].uuid] = response.body.price_templates[this.priceTemplate.uuid];
            })

            return priceTemplateValuesByOrderProductUuid;
        }
    },
    beforeUnmount() {
        this.task.cancel();
    }
}
</script>